export {default as menuDirectiveTemp} from './menu.html';
export {default as taglineDirectiveTemp} from './tagline.html';
export {default as sliderDirectiveTemp} from './slider.html';
export {default as footerTaglineDirectiveTemp} from './footerTagline.html';
export {default as videoBlockDirectiveTemp} from './videoBlock.html';
export {default as modelBlockDirectiveTemp} from './modelBlock.html';
export {default as comingSoonVideosDirectiveTemp} from './comingSoonVideos.html';



//////////////////
// WEBPACK FOOTER
// ./~/core_theme_2/src/templates/directives/index.js
// module id = 149
// module chunks = 0